import { createStore, createEffect, createEvent, combine } from 'effector';
import { RegistrationApi, type VerifyRequest, type VerifyResponse } from '@shared/api';
import { ApiUtils, AuthUtils } from '@shared/utils';

const verifyEffect = createEffect((request: VerifyRequest) => RegistrationApi.verify(request));
const clearEvent = createEvent();

const $dataStore = createStore<VerifyResponse | null>(null)
  .on(verifyEffect.done, (_, data) => {
    AuthUtils.setToken('verifyToken', data.result.data?.token);
    return data.result.data || null;
  })
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(verifyEffect.pending, (_, data) => data)
  .on(verifyEffect.fail, () => false)
  .on(verifyEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(verifyEffect, () => null)
  // .on(verifyEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(verifyEffect.fail, (_, data) => ApiUtils.getApiErrorData(data.error, 'Something went wrong while verifying. Please try again.').message)
  .on(verifyEffect.done, () => null)
  .reset(clearEvent);

export const $verifyStore = {
  events: {
    verify: verifyEffect,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
